/**
 * Created by vladislav on 31/10/2022
 */

const Merge2Customers = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.customers = [];

    this.cooldownQueue = new Merge2CustomersQueue(this);

    this.isExchanging = false;
    this.customOrdersQueue = [];
    this.plannedOrders = [];

    this.storedOrders = this.loadStoredOrders();

    Merge2Customers.CUSTOMERS_CONFIG.forEach((config) => {
        const customer = new Merge2Customer(config.id, this);
        this.customers.push(customer);
    });

    cleverapps.eventBus.on("merge2CustomersForceUpdateReward", this.forceRewardsUpdate.bind(this), this);
};

Merge2Customers.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2Customers.prototype.constructor = Merge2Customers;

Merge2Customers.prototype.loadStoredOrders = function () {
    const stored = this.slot.load("orders");

    if (stored && Array.isArray(stored)) {
        return this.extractCompactData(stored);
    }
};

Merge2Customers.prototype.createStoredOrders = function () {
    const storedOrders = this.storedOrders;

    this.customers.forEach((customer) => {
        const storedOrder = storedOrders && storedOrders.find((d) => d.customer === customer.customerIndex);

        if (storedOrder && storedOrder.ingredients && storedOrder.ingredients.length > 0) {
            let hasGeneratorForIngredients = true;
            storedOrder.ingredients.forEach((ingredient) => {
                if (!Families[ingredient.unit.code] || !Families[ingredient.unit.code].units[ingredient.unit.stage]) {
                    hasGeneratorForIngredients = false;
                } else if (!OrdersAlgoHelper.GeneratorForItem(ingredient.unit.code, OrdersAlgoHelper.DefaultGenerators()) && !Unit.isSideQuest(ingredient.unit.code)) {
                    cleverapps.throwAsync(`no Generator for ingredient ${ingredient.unit.code} in order`);
                    hasGeneratorForIngredients = false;
                }
            });
            if (hasGeneratorForIngredients) {
                customer.order(storedOrder);

                if (cleverapps.raveReviews.isOrderBadged(storedOrder.index)) {
                    customer.setRaveReviewsReward(true, true);
                }
            }
        }
    });

    this.addReviews(true);
};

Merge2Customers.prototype.addReviews = function (silent) {
    if (!cleverapps.raveReviews.isAvailable()) {
        return;
    }

    let reviewsInOrders = this.countRaveReviewsInOrders();

    const availableReviews = cleverapps.raveReviews.calcAvailableReviews();

    let balance = availableReviews - reviewsInOrders;
    if (balance <= 0 || this.cooldownQueue.reserve === 0 && reviewsInOrders > 0) {
        return;
    }

    let assigned = false;
    this.listCustomersWithRecipe().forEach((customer) => {
        if (customer.hasRaveReviewsReward() || customer.recipe.sideQuest || customer === this.findEventCustomer() || customer.recipe.isAutoOrder) {
            return;
        }

        if (balance > 2 || reviewsInOrders === 0) {
            const reward = cleverapps.raveReviews.calcOrderReward(customer.recipe.calcOrderStars());

            customer.setRaveReviewsReward(true, silent);
            assigned = true;
            reviewsInOrders += reward;
            balance = availableReviews - reviewsInOrders;
        }
    });

    if (assigned) {
        cleverapps.raveReviews.save();
    }
};

Merge2Customers.prototype.countRaveReviewsInOrders = function () {
    return this.listCustomersWithRecipe()
        .filter((customer) => customer.hasRaveReviewsReward())
        .reduce((sum, customer) => sum + cleverapps.raveReviews.calcOrderReward(customer.recipe.calcOrderStars()), 0);
};

Merge2Customers.prototype.startExchangeTimeout = function (duration) {
    if (this.isExchanging && this._exchangeCompleteTime - cleverapps.timeouts.getTime() >= duration) {
        return;
    }
    this.isExchanging = true;
    this._exchangeCompleteTime = cleverapps.timeouts.getTime() + duration;
    if (this.exchangeTimeout) {
        cleverapps.timeouts.clearTimeout(this.exchangeTimeout);
    }

    this.exchangeTimeout = cleverapps.timeouts.setTimeout(() => {
        this.isExchanging = false;

        if (this._processAfterExchange) {
            this._processAfterExchange = false;
            this.process();
        }
    }, duration);
};

Merge2Customers.prototype.process = function () {
    if (this.isExchanging) {
        this._processAfterExchange = true;

        return;
    }

    if (this.needUpdateMarks) {
        this.needUpdateMarks = false;

        const requiredAmounts = {};

        this.listCustomersWithRecipe().forEach((customer) => {
            customer.getCurrentRecipe().getIngredients().forEach((ingredient) => {
                if (ingredient.unit) {
                    const key = Unit.GetKey(ingredient.unit);
                    requiredAmounts[key] = (requiredAmounts[key] || 0) + ingredient.amount;
                }
            });
        });

        const picked = Merge2.current.stock.pickUnits(requiredAmounts);

        const marked = new Set(picked.units);

        Merge2.current.field.listAvailableUnits((unit) => {
            unit.setCustomerMark(marked.has(unit));
        });

        Merge2.current.backpack.setMarks(picked.backpackIndexes);
    }

    for (const { customer, order } of this.customOrdersQueue) {
        this.createCustomOrder(customer, order);
    }

    this.customOrdersQueue = [];

    if (cleverapps.tutorial.isActive()) {
        return;
    }
    
    this.makeNewOrders();

    if (this.needUpdateRewards) {
        this.needUpdateRewards = false;

        this.customers.forEach((customer) => {
            customer.updateRewards();
        });

        this.trigger("onRewardsUpdated");
    }

    if (this.listCustomersWithRecipe().length === 0) {
        cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
    }
};

Merge2Customers.prototype.checkAutoOrder = function () {
    if (this.listCustomersWithRecipe().find((customer) => customer.recipe.isAutoOrder)) {
        return;
    }

    let ingredients;
    const duplicates = {};
    Merge2.current.field.listAvailableUnits().forEach((unit) => {
        if (ingredients) {
            return;
        }

        if (Merge2CustomerRecipe.IsBigStageUnit(unit)) {
            ingredients = [{ unit, amount: 1 }];
            return;
        }

        if (Merge2CustomerRecipe.IsSecondLineMaxStageUnit(unit)) {
            if (duplicates[unit.code]) {
                ingredients = [{ unit, amount: 2 }];
            } else {
                duplicates[unit.code] = true;
            }
        }
    });

    if (ingredients) {
        this.planOrder({ ingredients }, "autoOrder");
        cleverapps.playSession.logEvent(cleverapps.EVENTS.AUTO_ORDER);
        return true;
    }
    return false;
};

Merge2Customers.prototype.getMaxCustomerIndex = function () {
    const stage = cleverapps.meta.getSelectedLocation().getContinuousStage();
    let maxCustomerIndex;

    Merge2Customers.CUSTOMERS_CONFIG.forEach((config) => {
        if (config.availableByFix !== undefined && stage >= config.availableByFix) {
            maxCustomerIndex = config.id;
        }
    });

    return maxCustomerIndex;
};

Merge2Customers.prototype.isNewOrderAvailable = function (customer) {
    if (customer.customerIndex === Merge2Customers.SIDE_QUEST_CUSTOMER_INDEX) {
        return false;
    }

    if (customer === this.findEventCustomer()) {
        return false;
    }

    if (customer.getCurrentRecipe()) {
        return false;
    }

    return customer.customerIndex <= this.getMaxCustomerIndex();
};

Merge2Customers.prototype.resetCustomerCooldown = function (customer) {
    this.cooldownQueue.remove(customer.customerIndex);
};

Merge2Customers.prototype.clearCooldown = function () {
    this.cooldownQueue.reset();
    this.process();
};

Merge2Customers.prototype.planOrder = function (order, type) {
    if (this.plannedOrders.some((planned) => planned.type === type)) {
        return;
    }

    this.plannedOrders.push({ order, type });
};

Merge2Customers.prototype.resetPlanedOrders = function () {
    this.plannedOrders = [];
};

Merge2Customers.prototype.createCustomOrder = function (customer, order) {
    if (this.isExchanging) {
        this._processAfterExchange = true;
        this.customOrdersQueue.push({
            customer,
            order
        });
        return;
    }

    if (customer.recipe) {
        order.index = customer.recipe.index;
        customer.replaceOrder(order);
    } else {
        this.resetCustomerCooldown(customer);
        order.index = Merge2.current.orderManager.index;
        Merge2.current.orderManager.inc();
        customer.order(order);
    }

    this.save();

    if (!customer.recipe.sideQuest) {
        Merge2.current.orderManager.simpleAlgorithm.updateAfterOrder(customer.recipe.ingredients.map((ingredient) => ({
            line: ingredient.unit.code,
            stage: ingredient.unit.stage
        })));
    }
};

Merge2Customers.prototype.makeNewOrders = function () {
    const orderManager = Merge2.current.orderManager;

    let currentAmount = this.listCustomersWithNormalOrders().length;
    if (currentAmount < 1 || cleverapps.raveReviews.isAvailable()
        && cleverapps.raveReviews.calcAvailableReviews() > 0
        && this.countRaveReviewsInOrders() === 0) {
        this.cooldownQueue.shift();
    }

    if (this.checkAutoOrder()) {
        this.cooldownQueue.shift();
    }

    this.customers.forEach((customer) => {
        if (!this.isNewOrderAvailable(customer) || this.cooldownQueue.has(customer.customerIndex)
            || currentAmount >= Merge2Customers.MAX_NORMAL_CUSTOMERS_AMOUNT) {
            return;
        }

        if (this.plannedOrders.length) {
            this.createCustomOrder(customer, this.plannedOrders.shift().order);
            return;
        }

        const order = orderManager.generateOrder();
        if (order) {
            customer.order(order);
            orderManager.inc();
            this.save();
            this.addReviews(true);
            currentAmount++;
        }
    });
};

Merge2Customers.prototype.destructor = function () {
    runCleaners(this);
    this.cooldownQueue.clearInterval();
    if (this.exchangeTimeout) {
        cleverapps.timeouts.clearTimeout(this.exchangeTimeout);
    }
};

Merge2Customers.prototype.list = function () {
    return this.customers;
};

Merge2Customers.prototype.findEventCustomer = function () {
    return this.customers.find((c) => {
        const config = Merge2Customers.CUSTOMERS_CONFIG.find((cfg) => cfg.id === c.customerIndex);
        return config && config.isEvent;
    });
};

Merge2Customers.prototype.listCustomersWithRecipe = function () {
    return this.customers.filter((customer) => customer.recipe);
};

Merge2Customers.prototype.isUnitNeeded = function (unit) {
    const stock = Merge2.current.stock;

    const ingredients = [];
    this.listCustomersWithRecipe().forEach((customer) => {
        customer.getCurrentRecipe().getIngredients().forEach((ingredient) => {
            if (ingredient.unit && ingredient.unit.code === unit.code) {
                ingredients.push(ingredient);
            }
        });
    });

    return ingredients.some((ingredient) => ingredient.unit.stage >= unit.stage && stock.getLackingAmount(ingredient) > 0);
};

Merge2Customers.prototype.listCustomersWithNormalOrders = function () {
    return this.customers.filter((customer) => {
        const config = Merge2Customers.CUSTOMERS_CONFIG.find((cfg) => cfg.id === customer.customerIndex);

        return customer.recipe
            && !(config && config.isEvent)
            && !customer.recipe.sideQuest
            && !customer.recipe.isAutoOrder;
    });
};

Merge2Customers.prototype.listCanCook = function () {
    return this.customers.filter((customer) => customer.canCook());
};

Merge2Customers.prototype.getSideQuestCustomer = function () {
    return this.listCustomersWithRecipe().find((customer) => customer.recipe.sideQuest);
};

Merge2Customers.prototype.startNextSideQuest = function (prevSideQuest) {
    const current = Merge2Customers.SIDE_QUEST_GENERATORS.find((generator) => generator.code === prevSideQuest);
    const index = Merge2Customers.SIDE_QUEST_GENERATORS.indexOf(current);
    const next = Merge2Customers.SIDE_QUEST_GENERATORS[(index + 1) % Merge2Customers.SIDE_QUEST_GENERATORS.length];
    this.startSideQuest(next);
};

Merge2Customers.prototype.startSideQuest = function (generator) {
    const scenario = cleverapps.tutorial.findScenario(SideQuestTutorial.NAME);

    if (!scenario.isAvailable()) {
        return;
    }

    this.createSideQuestOrder(generator.code);

    SideQuestTutorial.GENERATOR = generator;
    cleverapps.tutorial.startScenario(scenario);
};

Merge2Customers.prototype.createSideQuestOrder = function (sideQuest) {
    const customer = this.customers.find((c) => c.customerIndex === Merge2Customers.SIDE_QUEST_CUSTOMER_INDEX);
    const generator = Merge2Customers.SIDE_QUEST_GENERATORS.find((generator) => generator.code === sideQuest);
    const drops = Merge2Customers.getSideQuestDrops(generator);
    this.createCustomOrder(customer, {
        ingredients: drops.map((drop) => ({ unit: { code: drop, stage: UnitsLibrary.LastStage(drop).stage }, amount: 1 }))
    });
};

Merge2Customers.prototype.onCompleteOrder = function (customer, recipe) {
    if (recipe.sideQuest) {
        Merge2.current.removeExpiredSideQuestUnits();
        this.startNextSideQuest(recipe.sideQuest);
        return;
    }

    if (customer === this.findEventCustomer()) {
        this.save();
        return;
    }
    if (this.getMaxCustomerIndex() > 0) {
        this.cooldownQueue.add(customer.customerIndex);
    }

    this.save();
};

Merge2Customers.prototype.onRecipesUpdated = function () {
    this.trigger("onRecipesUpdated", !Merge2.current.initStageRunned);
};

Merge2Customers.prototype.updateMarks = function () {
    this.needUpdateMarks = true;
    if (cleverapps.Scenes.GetRunningScene().introShown) {
        Merge2.current.counter.trigger(1);
    }
};

Merge2Customers.prototype.forceRewardsUpdate = function () {
    this.needUpdateRewards = true;
    Merge2.current.counter.trigger(1);
};

Merge2Customers.prototype.save = function () {
    const ordersData = [];
    this.customers.forEach((customer) => {
        if (customer.recipe) {
            ordersData.push(this.compactOrderData(customer.customerIndex, customer.recipe));
        } else {
            ordersData.push([customer.customerIndex]);
        }
    });

    this.slot.save("orders", ordersData);
};

Merge2Customers.prototype.compactOrderData = function (customerIndex, data) {
    const ingredients = data.ingredients.map((ing) => {
        const code = ing.unit.code;
        const stage = Base80.compactNumber(ing.unit.stage);
        const amount = Base80.compactNumber(ing.amount);
        return code + stage + amount;
    }).join(",");

    return [customerIndex, ingredients, [], data.index];
};

Merge2Customers.prototype.extractCompactData = function (compactArray) {
    let error;
    const extracted = compactArray.filter((order) => Array.isArray(order)).map((order) => {
        const customer = order[0];
        if (order.length < 2) {
            return { customer };
        }

        if (order.length !== 4) {
            error = true;
            return;
        }

        const ingredients = order[1].split(",").map((item) => {
            if (item.length < 3) {
                error = true;
                return;
            }
            const l = item.length;
            const stage = Base80.expandNumber(item.substring(l - 2, l - 1));
            const unit = { code: item.substring(0, l - 2), stage };
            return {
                unit: {
                    code: unit.code,
                    stage: unit.stage
                },
                amount: Base80.expandNumber(item.substring(l - 1)) 
            };
        });

        if (ingredients.length > 3) {
            error = true;
            return;
        }

        const index = order[3];

        return {
            customer, ingredients, index
        };
    });

    if (error) {
        cleverapps.throwAsync(`extract wrong format '${JSON.stringify(compactArray)}'`);
        return;
    }

    return extracted;
};

Merge2Customers.getSideQuestGenerator = function (line) {
    let sideQuestGenerator;
    Merge2Customers.SIDE_QUEST_GENERATORS.forEach((generator) => {
        if (Merge2Customers.getSideQuestDrops(generator).includes(line)) {
            sideQuestGenerator = generator;
        }
    });
    return sideQuestGenerator;
};

Merge2Customers.getSideQuestDrops = function (generator) {
    const config = OrdersAlgoConfig.generators[generator.code];
    if (config.algorithm && config.algorithm.overrideDrop) {
        return config.algorithm.overrideDrop;
    }
    return config.stages[generator.stage].drop;
};

Merge2Customers.isSideQuestPassed = function (generator) {
    return Merge2Customers.getSideQuestDrops(generator).every(
        (drop) => cleverapps.unitsLibrary.isOpened({ code: drop, stage: UnitsLibrary.LastStage(drop).stage })
    );
};

Merge2Customers.findSideQuestToStart = function () {
    const generators = Merge2Customers.SIDE_QUEST_GENERATORS;
    return generators.find((generator) => !Merge2Customers.isSideQuestPassed(generator)) || generators[0];
};

// https://docs.google.com/spreadsheets/d/1vpwcn58yMyCg4vcs4ikx9PJZUs3L8z8rQ_Xfnk74UEs/edit?gid=1479010405#gid=1479010405
Merge2Customers.CUSTOMERS_CONFIG = [
    { id: 0, availableByFix: 0 },
    { id: 1, availableByFix: 1 },
    { id: 2, availableByFix: 5 },
    { id: 3, availableByFix: 6 },
    { id: 4, availableByFix: 16 },
    { id: 5, availableByFix: 16 },
    { id: 6, availableByFix: 24 },
    { id: 7, availableByFix: 69 },
    { id: 8, isEvent: true }
];

Merge2Customers.SIDE_QUEST_GENERATORS = [{ code: "O", stage: 3 }, { code: "P", stage: 3 }, { code: "QR", stage: 3 }, { code: "SS", stage: 0 }, { code: "T", stage: 0 }, { code: "U", stage: 0 }];
Merge2Customers.SIDE_QUEST_REWARDS = {
    O: {
        rubies: 30,
        energy: 100 
    },
    P: {
        rubies: 30,
        energy: 100
    },
    QR: {
        rubies: 60,
        energy: 150
    },
    SS: {
        rubies: 60,
        energy: 150
    },
    T: {
        rubies: 50,
        orderStar: 400
    },
    U: {
        rubies: 50,
        energy: 200
    }
};

Merge2Customers.MAX_NORMAL_CUSTOMERS_AMOUNT = 6;
Merge2Customers.SIDE_QUEST_CUSTOMER_INDEX = 4;
